 
/* eslint-disable @typescript-eslint/no-explicit-any */
import { LocalizationContext } from "@app/context/LocalizationContext";
import STORAGE_KEYS from "@src/constants/storageKeys";
import useLocalStorage from "@src/hooks/useLocalStorage";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./LocalizationRoot";

type LocalizationProviderProps = { children: ReactNode }

export function LocalizationProvider ({ children }: LocalizationProviderProps) {
  const { i18n, t } = useTranslation();
  const { set } = useLocalStorage();
  const setI18nConfig = (language:any) => {
    i18n.changeLanguage(language).then((tr:any) => {
      tr(language);
    });
  };

  const getTranslation = (text:any, argumentsData:any) => t(text, argumentsData);

  const getUserLanguage = () => {
    const { language } = i18n;
    return language;
  };

  const saveUserLanguage = async (language:any) => {
    setI18nConfig(language);
    await set(STORAGE_KEYS.selected_language, language);
  };

  return (
    <LocalizationContext.Provider
      value={{
        setI18nConfig,
        getTranslation,
        getUserLanguage,
        saveUserLanguage
      }}
    >
      {children}
    </LocalizationContext.Provider>
  );
};